import React, { useEffect, useState } from 'react';
import {
    Drawer,
    Form,
    Input,
    Select,
    Button,
    Space,
    message,
    Typography,
    Alert
} from 'antd';
import { TeamOutlined, GlobalOutlined } from '@ant-design/icons';
import { roleService } from '../services/api';

const { Option } = Select;
const { Text } = Typography;

const PRIMARY_RED = '#DA291C';

const validateMessages = {
    required: '${label} es obligatorio',
};

const RoleDrawer = ({ visible, onClose, mode, roleData, onSuccess }) => {
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [selectedPortal, setSelectedPortal] = useState(null);

    useEffect(() => {
        if (visible) {
            if (mode === 'edit' && roleData) {
                form.setFieldsValue({
                    name: roleData.name,
                    portal: roleData.portal
                });
                setSelectedPortal(roleData.portal);
            } else {
                form.resetFields();
                setSelectedPortal(null);
            }
        }
    }, [visible, mode, roleData, form]);

    const handlePortalChange = (value) => {
        setSelectedPortal(value);
    };



    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            let response;
            if (mode === 'create') {
                response = await roleService.create(values);
            } else {
                response = await roleService.update({ ...values, uuid: roleData.uuid });
            }

            if (response.status === 'success') {
                message.success(`Rol ${mode === 'create' ? 'creado' : 'actualizado'} exitosamente`);
                onSuccess();
                onClose();
            }
        } catch (error) {
            if (error.errorFields) return;
            message.error(error.response?.data?.message || 'Ocurrió un error en la operación');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Drawer
            title={mode === 'create' ? "Nuevo Rol" : "Editar Rol"}
            width={450}
            onClose={onClose}
            open={visible}
            extra={
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button
                        type="primary"
                        onClick={handleSubmit}
                        loading={loading}
                        style={{ background: PRIMARY_RED, borderColor: PRIMARY_RED }}
                    >
                        Guardar
                    </Button>
                </Space>
            }
        >
            <Form
                form={form}
                layout="vertical"
                validateMessages={validateMessages}
                initialValues={{ portal: 'admin' }}
            >
                <Form.Item
                    label="Nombre del Rol"
                    name="name"
                    rules={[{ required: true }]}
                >
                    <Input placeholder="Ej. Supervisor de Campo" prefix={<TeamOutlined />} />
                </Form.Item>

                <Form.Item
                    label="Portal"
                    name="portal"
                    rules={[{ required: true }]}
                    extra={mode === 'edit' ? "El portal no se puede cambiar desde aquí. Use la opción 'Cambiar Portal' en el menú de acciones." : "Define el contexto de acceso."}
                >
                    <Select
                        disabled={mode === 'edit'}
                        onChange={handlePortalChange}
                    >
                        <Option value="admin">Administrador</Option>
                        <Option value="agent">Agente</Option>
                    </Select>
                </Form.Item>


            </Form>
        </Drawer>
    );
};

export default RoleDrawer;
